<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Remove Lines Containing</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs9>
            <v-text-field label="String to remove" v-model="string"></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-checkbox v-model="ignore" label="Ignore Case" color="primary"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="remove()">Remove</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: '',
    string: '',
    ignore: false
  }),
  methods: {
    remove() {
      let lines = this.text.split('\n')
      this.result = lines.filter((line, i) => {
        if (!line.includes(this.string)) {
          if (line.toLowerCase().includes(this.string.toLowerCase())) {
            if (!this.ignore) return line
          } else {
            return line
          }
        }
      }).join('\n')
    }
  }
}
</script>

<style>
</style>